module.exports = __webpack_public_path__ + "img/antes_despues_59.8885afd8.png";